module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTMwOC40IDI2My4xTDUxMiA0NjYuN2wyMDMuNi0yMDMuNmEzMiAzMiAwIDAgMSA0Mi4yLTIuN2wzIDIuN2EzMiAzMiAwIDAgMSAyLjcgNDIuMmwtMi43IDNMNTU3LjIgNTEybDIwMy42IDIwMy42YTMyIDMyIDAgMCAxLTQ1LjIgNDUuMkw1MTIgNTU3LjJsLTIwMy42IDIwMy42YTMyIDMyIDAgMCAxLTQyLjIgMi43bC0zLTIuN2EzMiAzMiAwIDAgMS0yLjctNDIuMmwyLjctM0w0NjYuNyA1MTIgMjYzLjEgMzA4LjRhMzIgMzIgMCAwIDEgNDUuMi00NS4yeiIgZmlsbD0iIzAiIHAtaWQ9IjY4NiI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Close-outlined.svg
// module id = me1W
// module chunks = 73